import React from "react";
import { motion } from "framer-motion";
import { Sparkles, X } from "lucide-react";

export const DockHint = ({ onDismiss }) => (
  <motion.div
    initial={{ opacity: 0, y: 8, scale: 0.95 }}
    animate={{ opacity: 1, y: 0, scale: 1 }}
    exit={{ opacity: 0, y: 8, scale: 0.95 }}
    transition={{ type: "spring", damping: 22, stiffness: 260 }}
    className="fixed bottom-24 right-6 z-50 max-w-[260px]"
    data-testid="officer-dock-hint"
  >
    <div className="relative rounded-2xl bg-gradient-to-br from-[#1a0f2e] to-[#0a0a0f] border border-purple-500/30 shadow-2xl shadow-purple-500/20 p-4">
      <button
        onClick={onDismiss}
        className="absolute top-2 right-2 w-6 h-6 rounded-lg hover:bg-white/5 flex items-center justify-center text-gray-500 hover:text-white transition-colors"
        aria-label="Cerrar tooltip"
        data-testid="officer-dock-hint-dismiss"
      >
        <X className="w-3 h-3" />
      </button>
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-3.5 h-3.5 text-purple-300" />
        <p className="text-[10px] uppercase tracking-widest text-purple-300 font-bold">Pregúntame lo que necesites</p>
      </div>
      <p className="text-xs text-gray-300 leading-relaxed">
        Soy uno de los <span className="text-white font-semibold">6 AI Officers</span> de PROXIMA. Analizo riesgos, redacto comunicados de crisis y genero estrategia en segundos.
      </p>
      {/* Arrow pointing to button */}
      <div className="absolute -bottom-1.5 right-9 w-3 h-3 rotate-45 bg-[#0a0a0f] border-r border-b border-purple-500/30" />
    </div>
  </motion.div>
);
